<template>
  <div id="MyInput">
    <img v-if="ipt.icon" :src="ipt.icon" class="icon" />
    <input :placeholder="ipt.label" v-bind="ipt" class="glFlex" />
    <img @click="ipt.tapRight && ipt.tapRight()" v-if="ipt.rightIcon" :src="ipt.rightIcon" class="icon" />
  </div>
</template>

<script lang="ts">
import { InputHTMLAttributes, PropType } from 'vue';

interface Ipt extends InputHTMLAttributes {
  label: string;
  icon: any;
  rightIcon: string;
  rightText: string;
  tapRight: Function;
}
export default {
  name: "MyInput",
  props: {
    ipt: {
      type: Object as PropType<Ipt>,
      default: {},
    }
  },
}
</script>

<style scoped>
#MyInput {
  display: flex;
  align-items: center;
  margin: 4px var(--dimApp);
  border: 1px solid var(--colorBorder);
  border-radius: 2px;
  padding: var(--dimText);
  overflow: hidden;
}

.icon {
  width: var(--dimText);
  height: var(--dimText);
  object-fit: contain;
  margin-right: var(--dimText);
}
</style>